"use client";

import { useFadeInOnReady, useLoadingOverlayExit } from "@/hooks/use-game-player-ready-fade";
import { GAME_PLAYER_READY_FADE_MS } from "@/lib/constants/layout";
import { Z_INDEX_CLASSES } from "@/lib/constants/z-index";
import { cn } from "@/lib/utils";
import type { ReactNode } from "react";
import { GamePlayerLoadingOverlay } from "./game-player-loading";

interface GamePlayerLoadingGateProps {
  loading: boolean;
  progress?: number;
  isMobile?: boolean;
  className?: string;
  children: ReactNode;
}

export function GamePlayerLoadingGate({
  loading,
  progress,
  isMobile = false,
  className,
  children,
}: GamePlayerLoadingGateProps) {
  const { overlayMounted, overlayVisible } = useLoadingOverlayExit(loading);
  const { fadeClassName, fadeStyle } = useFadeInOnReady(!loading);

  return (
    <div className={cn("relative h-full w-full", className)}>
      <div className={cn("absolute inset-0 h-full w-full", fadeClassName)} style={fadeStyle}>
        {children}
      </div>

      {overlayMounted ? (
        <GamePlayerLoadingOverlay
          progress={progress}
          isMobile={isMobile}
          className={cn(
            `${Z_INDEX_CLASSES.GAME_PLAYER_LOADING_OVERLAY} transition-opacity ease-out`,
            overlayVisible ? "opacity-100" : "opacity-0"
          )}
          style={{ transitionDuration: `${GAME_PLAYER_READY_FADE_MS}ms` }}
        />
      ) : null}
    </div>
  );
}
